<template>
  <div class="row q-col-gutter-xs items-baseline">
    <div class="col-auto">
      <q-btn color="positive" flat dense size="xs" icon="content_copy" @click="doCopy">
        <q-tooltip>{{ $t('Common.Copy.Text') }}</q-tooltip>
      </q-btn>
    </div>
    <div class="col-auto cursor-pointer">
      {{ text }}
      <q-tooltip v-if="copied" v-model="copied" content-class="bg-positive" anchor="center right" self="center left">
        <q-icon name="done"></q-icon> {{ $t('Common.Copied.Text') }}
      </q-tooltip>
    </div>
  </div>
</template>
<script>
export default {
  name: 'CopyText',
  props: {
    text: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    copied: false,
  }),
  methods: {
    doCopy: function() {
      this.$copyText(this.text).then(() => {
        this.copied = true
        setTimeout(() => {
          this.copied = false
        }, 4000)
      })
    },
  },
}
</script>
